import axios from "axios";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import api from "../api";
import { IFeature } from "../api/services/feature.service";
import FeatureCombobox from "./shared/FeatureCombobox";

export default function FeatureDialogListSection({
  features,
  userId,
}: {
  features: IFeature[];
  userId: string;
}) {
  const [selectedFeature, setSelectedFeature] = useState<IFeature | null>(null);

  useEffect(() => {
    setSelectedFeature(null);
  }, [features]);

  useEffect(() => {
    if (selectedFeature && userId) {
      enableFeatureForUser(selectedFeature.id, userId);
    }
  }, [userId, selectedFeature]);

  async function enableFeatureForUser(featureId: string, userId: string) {
    try {
      const { status } = await api.feature.enableFeatureForUser(
        featureId,
        userId
      );
      if (status === 204) {
        toast.success("Added feature to user");
        // fetchProjectMembers();
      }
    } catch (e) {
      if (axios.isAxiosError(e)) {
        if (e.response?.data) {
          toast.error(e.response?.data.errorMessage);
        }
      } else {
        console.log(e);
        toast.error(
          "Something really went wrong, you might want to contact support!"
        );
      }
    }
  }

  return (
    <div className="flex flex-col rounded-md pb-2">
      <span className="text-slate-500 dark:text-slate-400 text-sm">
        {
          "Select an artist that you have previously worked with or invite them by email"
        }
      </span>
      <div className="flex flex-col justify-center mt-4">
        <div className="flex justify-center">
          <div className="flex-grow">
            <FeatureCombobox
              features={features}
              selected={selectedFeature}
              setSelected={setSelectedFeature}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
